import { createSlice } from "@reduxjs/toolkit";

export const centerProductsListSlice = createSlice({
  name: "centerProductsList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedCenterProduct: null,
    filteredRecords: 0,
    isSingleCenterProductLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
    isSingleCenterProductNotFound: false,
  },
  reducers: {
    setAllCenterProductsLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleCenterProductsLoadingState: (state, action) => {
      state.isSingleCenterProductLoading = true;
    },
    loadAllCenterProducts: (state, action) => {
      const listObj = {};
      action.payload.centerProducts.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.centerProducts.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleCenterProduct: (state, action) => {
      state.selectedCenterProduct =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleCenterProductLoading = false;
    },
    setSingleCenterProductNotFound: (state, action) => {
      state.isSingleCenterProductNotFound = action.payload;
    },
  },
});

export const {
  setAllCenterProductsLoadingState,
  setSingleCenterProductsLoadingState,
  loadAllCenterProducts,
  loadSingleCenterProduct,
  setSingleCenterProductNotFound,
} = centerProductsListSlice.actions;

export default centerProductsListSlice.reducer;
